import { call, put, takeEvery } from 'redux-saga/effects';
import { captureException } from '@sentry/react';
import Notifications from 'react-notification-system-redux';

import { api } from '../../../api';
import {
  DISPATCH_UBER_BATCH_RESOLVE,
  DISPATCH_UBER_BATCH_RESOLVED,
  DISPATCH_UBER_BATCH_ERROR,
} from '../actions/uberResolve';
import { dockUpdated } from '../actions/dock';
import { _utilUpdateTasks } from './deliveries';

/**
 * Saga that handles resolving a canceled Uber batch task.
 * Calls the API to extract the task from the dock and clear Uber fields.
 */
function* resolveUberBatchTaskSaga(action) {
  const { task, dock, deliveryId } = action;
  const taskId = task.id;
  const orderRandomId = task.linked_order && task.linked_order.random_id;

  try {
    const response = yield call(api.uberCancelResolve, task, deliveryId);
    
    // Success - dispatch resolved action
    yield put({
      type: DISPATCH_UBER_BATCH_RESOLVED,
      taskId: taskId,
      newDock: response.new_dock || null,
      // dockId permet au reducer modal de mettre à jour l'état
      dockId: dock.id,
    });

    // Notification de succès
    const message = orderRandomId
      ? `Commande #${orderRandomId} extraite du dock`
      : 'Commande extraite du dock';
    yield put(Notifications.success({
      title: 'Extraction reussie',
      message: message,
      autoDismiss: 5,
      dismissible: 'click',
    }));

    // Update the dock if response contains updated dock data
    if (response.dock) {
      yield put(dockUpdated(response.dock));
    }

    // Refresh tasks to reflect changes
    yield* _utilUpdateTasks((t) => t.dock && t.dock.id === dock.id);

  } catch (error) {
    captureException(error);
    
    // Extract error message
    let errorMessage = 'Une erreur est survenue lors de l\'extraction';
    if (error.response && error.response.data) {
      const errorData = error.response.data;
      if (errorData.error) {
        errorMessage = errorData.error;
      } else if (errorData.message) {
        errorMessage = errorData.message;
      } else if (errorData.detail) {
        errorMessage = errorData.detail;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    // Dispatch error action - modal stays open
    yield put({
      type: DISPATCH_UBER_BATCH_ERROR,
      taskId: taskId,
      error: errorMessage,
    });

    // Notification visible même sans modale (extraction depuis le burger menu)
    yield put(Notifications.error({
      title: 'Extraction Uber',
      message: errorMessage,
      autoDismiss: 5,
      dismissible: 'click',
    }));
  }
}

export const uberResolveSagas = [
  takeEvery(DISPATCH_UBER_BATCH_RESOLVE, resolveUberBatchTaskSaga),
];
